import { QSET_REVIEW_SUBTASK_DATA_TEST_ID } from '@e2e/constants/exam-management';
import {
  GetReviewQSetSubtaskDetailsByIdDocument,
  SubmitQSetReviewErrorCode,
  useSubmitQSetReviewMutation,
} from '@exam-management/graphql';
import { TaskOverdueDialog } from '@exam-management/task-management';
import { Button, ConfirmationModal, SendOutlinedIcon } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { useSnackbar } from '@shared/snackbar';
import { useState } from 'react';

import { useQSetReviewSubtask } from '../../providers';

import SubmitReviewErrorModal from './submit-review-error-modal';

export default function SubmitReviewButton() {
  const {
    subtaskDetails: { id },
  } = useQSetReviewSubtask();
  const [submitQSetReview, { loading }] = useSubmitQSetReviewMutation();
  const { showSnackbar } = useSnackbar();
  const [isOpen, { open, close }] = useDisclosure();
  const [isErrorModalOpen, { open: openErrorModal, close: closeErrorModal }] = useDisclosure();
  const [isOverdueDialogOpen, { open: openOverdueDialog, close: closeOverdueDialog }] =
    useDisclosure();
  const [missingQuestionVerdictCount, setMissingQuestionVerdictCount] = useState(0);

  const handleSubmitReview = async () => {
    await submitQSetReview({
      variables: {
        submitQSetReviewInput: {
          taskId: id,
        },
      },
      onCompleted: (data) => {
        close();
        if (data.wflSubmitQSetReview.success) {
          showSnackbar({
            message: 'Review has been submitted',
            variant: 'success',
          });
        } else {
          const { code, missingQuestionVerdictCount: count } = data.wflSubmitQSetReview;
          setMissingQuestionVerdictCount(count);
          if (code === null) {
            showSnackbar({
              message: 'Failed to submit review',
              variant: 'error',
            });
            return;
          }
          if (code === SubmitQSetReviewErrorCode.TaskOverdue) {
            openOverdueDialog();
            return;
          }
          openErrorModal();
        }
      },
      onError: () => {
        showSnackbar({
          message: 'Failed to submit review',
          variant: 'error',
        });
      },
      refetchQueries: [GetReviewQSetSubtaskDetailsByIdDocument],
      awaitRefetchQueries: true,
    });
  };
  return (
    <>
      <Button
        startIcon={<SendOutlinedIcon />}
        onClick={() => open()}
        data-testid={QSET_REVIEW_SUBTASK_DATA_TEST_ID.SUBMIT_REVIEW_BUTTON}
      >
        Submit Review
      </Button>
      <ConfirmationModal
        title='Submit Review?'
        content='คุณต้องการส่งผลการรีวิวชุดข้อสอบนี้ใช่หรือไม่'
        open={isOpen}
        onAccept={handleSubmitReview}
        loading={loading}
        onDiscard={close}
        onClose={close}
      />
      <SubmitReviewErrorModal
        open={isErrorModalOpen}
        missingQuestionVerdictCount={missingQuestionVerdictCount}
        onClose={closeErrorModal}
      />
      <TaskOverdueDialog
        variant='submit-review'
        open={isOverdueDialogOpen}
        onClose={closeOverdueDialog}
      />
    </>
  );
}
